import Http from '../http'

export default {

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/clients`, {params: {...filter}})
  },

  create(client){
    return Http.post(`/clients`, {client: {
      ...client,
    }})
  },

  update(client){
    return Http.put(`/clients/${client.id}`, {
      client: {
        ...client,
      },
    });
  },

  show(id) {
    return Http.get(`/clients/${id}`);
  },

  showClientLastOrder(filter = {}) {
    return Http.get(`/client_last_orders`, {params: {...filter}});
  },

  delete(){
    // return Http.delete(`/action_plans/${id}`)
  }

}
